import {
  ChangeDetectorRef,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';

import { ProgressSpinnerComponent } from '../../components/core/progress-spinner/progress-spinner.component';

const OVERLAY_CLASS = 'loading-overlay';

@Directive({
  selector: '[appLoading]',
})
export class LoadingDirective implements OnChanges, OnDestroy {
  @Input('appLoading')
  isLoading = false;

  protected overlayElement!: HTMLDivElement;

  protected spinnerElement!: HTMLElement;

  protected hostElement!: HTMLDivElement;

  private spinnerRef: ComponentRef<ProgressSpinnerComponent> | null = null;

  constructor(
    protected readonly elementRef: ElementRef,
    protected readonly renderer: Renderer2,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    protected readonly viewContainerRef: ViewContainerRef,
  ) {
    this.hostElement = this.elementRef.nativeElement;
    this.hostElement.style.position = 'relative';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.overlayElement || !this.spinnerElement) {
      this.init();
    }

    if (changes.isLoading) {
      const isLoadingValue = changes.isLoading.currentValue;

      if (isLoadingValue) {
        this.addLoadingIndicator();
      } else {
        this.removeLoadingIndicator();
      }

      this.changeDetectorRef.markForCheck();
    }
  }

  ngOnDestroy(): void {
    this.removeLoadingIndicator();
    this.viewContainerRef.clear();
    this.spinnerRef = null;
  }

  protected addLoadingIndicator(): void {
    this.renderer.appendChild(this.hostElement, this.overlayElement);
    this.renderer.appendChild(this.overlayElement, this.spinnerElement);
    this.spinnerRef?.changeDetectorRef.detectChanges();
  }

  protected removeLoadingIndicator(): void {
    if (this.overlayElement?.parentNode === this.hostElement) {
      this.renderer.removeChild(this.overlayElement, this.spinnerElement);
      this.renderer.removeChild(this.hostElement, this.overlayElement);
    }
  }

  protected init(): void {
    this.initOverlayElement();
    this.initSpinnerComponent();
  }

  protected initSpinnerComponent(): void {
    this.spinnerRef = this.viewContainerRef.createComponent(ProgressSpinnerComponent);
    this.spinnerRef.changeDetectorRef.detectChanges();
    this.spinnerElement = this.spinnerRef.location.nativeElement;
  }

  protected initOverlayElement(): void {
    this.overlayElement = this.renderer.createElement('div');
    this.renderer.addClass(this.overlayElement, OVERLAY_CLASS);
  }
}
